import { render } from "./CardStars.vue?vue&type=template&id=86bed66a&scoped=true"
import script from "./CardStars.vue?vue&type=script&lang=js"
export * from "./CardStars.vue?vue&type=script&lang=js"

import "./CardStars.vue?vue&type=style&index=0&id=86bed66a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86bed66a"]])

export default __exports__